bootstrapHyphenopolyConfig();
export function bootstrapHyphenopolyConfig() {
    window.hyphenopolyConfig = window.hyphenopolyConfig || {};
    window.hyphenopolyConfig = Object.assign(Object.assign({}, window.hyphenopolyConfig), { selectors: [
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6', '.course__name'
        ] });
}
